export class FraudLimitsResponse {
    public name: string;
    public value: number;
    public timeframeName?: string;
    public timeframeValue?: number;
}
